if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.onModalKeydown = this.onModalKeydown.bind(this);
        this.onModalScroll = this.onModalScroll.bind(this);

        this.addEventListener(
          'pointerup',
          (event) => {
            if (
              event.target.closest(
                '.skim1-product-modal-nav, .skim1-product-modal-counter, .product-media-modal__toggle, .product-media-modal__content img, .product-media-modal__content video, .product-media-modal__content iframe, .product-media-modal__content model-viewer'
              )
            ) {
              event.stopImmediatePropagation();
            }
          },
          true
        );
      }

      connectedCallback() {
        super.connectedCallback();
        this.setupProductModal();
      }

      hide() {
        window.clearTimeout(this.skim1ModalScrollTimeout);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupProductModal();
        this.showActiveMedia();
      }

      setupProductModal() {
        if (this.dataset.skim1ProductModalReady === 'true') return;

        this.dataset.skim1ProductModalReady = 'true';
        this.modalContent = this.querySelector('.product-media-modal__content');
        this.currentCounter = this.querySelector('[data-skim1-product-modal-current]');
        this.prevButton = this.querySelector('[data-skim1-product-modal-prev]');
        this.nextButton = this.querySelector('[data-skim1-product-modal-next]');

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.navigateModal(-1);
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.navigateModal(1);
          });
        }

        if (this.modalContent) {
          this.modalContent.addEventListener('scroll', this.onModalScroll, { passive: true });
        }

        this.addEventListener('keydown', this.onModalKeydown);
        this.refreshModalSlides();
        this.updateModalCounter(0);
      }

      refreshModalSlides() {
        this.modalSlides = Array.from(this.querySelectorAll('[data-skim1-product-modal-slide]'));
        return this.modalSlides;
      }

      onModalKeydown(event) {
        if (!this.hasAttribute('open')) return;

        if (event.code === 'ArrowLeft') {
          event.preventDefault();
          this.navigateModal(-1);
        }

        if (event.code === 'ArrowRight') {
          event.preventDefault();
          this.navigateModal(1);
        }
      }

      onModalScroll() {
        if (!this.hasAttribute('open')) return;

        window.clearTimeout(this.skim1ModalScrollTimeout);
        this.skim1ModalScrollTimeout = window.setTimeout(() => this.updateActiveSlideFromScroll(), 80);
      }

      navigateModal(direction) {
        const slides = this.refreshModalSlides();
        if (slides.length < 2) return;

        const currentIndex = this.activeModalIndex || 0;
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;
        this.setActiveSlide(nextIndex);
      }

      setActiveSlide(index, options = {}) {
        const slides = this.refreshModalSlides();
        if (!slides.length) return;

        const animate = options.animate !== false;
        const nextIndex = (index + slides.length) % slides.length;
        const activeSlide = slides[nextIndex];

        this.activeModalIndex = nextIndex;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === nextIndex;
          slide.classList.toggle('active', isActive);
          slide.toggleAttribute('aria-hidden', !isActive);
        });

        this.updateModalCounter(nextIndex);
        this.loadActiveMedia(activeSlide);

        if (this.modalContent && activeSlide) {
          this.modalContent.scrollTo({
            left: activeSlide.offsetLeft,
            behavior: animate ? 'smooth' : 'auto',
          });
        }
      }

      updateModalCounter(index) {
        if (this.currentCounter) this.currentCounter.textContent = index + 1;
      }

      updateActiveSlideFromScroll() {
        const slides = this.refreshModalSlides();
        if (!slides.length || !this.modalContent) return;

        const contentRect = this.modalContent.getBoundingClientRect();
        const contentCenter = contentRect.left + contentRect.width / 2;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideRect = slide.getBoundingClientRect();
          const slideCenter = slideRect.left + slideRect.width / 2;
          const distance = Math.abs(slideCenter - contentCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        if (nearestIndex === this.activeModalIndex) return;

        this.activeModalIndex = nearestIndex;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === nearestIndex;
          slide.classList.toggle('active', isActive);
          slide.toggleAttribute('aria-hidden', !isActive);
        });
        this.updateModalCounter(nearestIndex);
        this.loadActiveMedia(slides[nearestIndex]);
      }

      loadActiveMedia(activeMedia) {
        if (!activeMedia) return;

        const mediaElement = activeMedia.matches('deferred-media, product-model')
          ? activeMedia
          : activeMedia.querySelector('deferred-media, product-model');
        const activeMediaTemplate = mediaElement ? mediaElement.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          mediaElement &&
          mediaElement.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          mediaElement.loadContent();
        }
      }

      showActiveMedia() {
        const mediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        const slides = this.refreshModalSlides();
        const activeSlideIndex = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);

        if (activeSlideIndex >= 0) {
          this.setActiveSlide(activeSlideIndex, { animate: false });
          return;
        }

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

        if (!activeMedia) return;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        this.loadActiveMedia(activeMedia);
      }
    }
  );
}
